/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_SetInputs */

const en_us2_exercise_personal_goal_set = /** @type {(inputs: Exercise_Personal_Goal_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a goal`)
};

const pt_br2_exercise_personal_goal_set = /** @type {(inputs: Exercise_Personal_Goal_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir meta`)
};

const es_419_exercise_personal_goal_set = /** @type {(inputs: Exercise_Personal_Goal_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir una meta`)
};

const pt_pt2_exercise_personal_goal_set = /** @type {(inputs: Exercise_Personal_Goal_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir objetivo`)
};

const fr_fr2_exercise_personal_goal_set = /** @type {(inputs: Exercise_Personal_Goal_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixer un objectif`)
};

const de_de2_exercise_personal_goal_set = /** @type {(inputs: Exercise_Personal_Goal_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel festlegen`)
};

const it_it2_exercise_personal_goal_set = /** @type {(inputs: Exercise_Personal_Goal_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta un obiettivo`)
};

/**
* | output |
* | --- |
* | "Set a goal" |
*
* @param {Exercise_Personal_Goal_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_set = /** @type {((inputs?: Exercise_Personal_Goal_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_set(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_set(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_set(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_set(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_set(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_set(inputs)
	return en_us2_exercise_personal_goal_set(inputs)
});
export { exercise_personal_goal_set as "exercise-personal.goal_set" }